import type { SVGProps } from 'react'

export const WorkspaceAdminIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 2.3H3C2.6134 2.3 2.3 2.6134 2.3 3V5C2.3 5.3866 2.6134 5.7 3 5.7H5C5.3866 5.7 5.7 5.3866 5.7 5V3C5.7 2.6134 5.3866 2.3 5 2.3ZM3 1C1.89543 1 1 1.89543 1 3V5C1 6.10457 1.89543 7 3 7H5C6.10457 7 7 6.10457 7 5V3C7 1.89543 6.10457 1 5 1H3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5 10.3H3C2.6134 10.3 2.3 10.6134 2.3 11V13C2.3 13.3866 2.6134 13.7 3 13.7H5C5.3866 13.7 5.7 13.3866 5.7 13V11C5.7 10.6134 5.3866 10.3 5 10.3ZM3 9C1.89543 9 1 9.89543 1 11V13C1 14.1046 1.89543 15 3 15H5C6.10457 15 7 14.1046 7 13V11C7 9.89543 6.10457 9 5 9H3Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 2.3H11C10.6134 2.3 10.3 2.6134 10.3 3V5C10.3 5.3866 10.6134 5.7 11 5.7H13C13.3866 5.7 13.7 5.3866 13.7 5V3C13.7 2.6134 13.3866 2.3 13 2.3ZM11 1C9.89543 1 9 1.89543 9 3V5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5V3C15 1.89543 14.1046 1 13 1H11Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13 10.3H11C10.6134 10.3 10.3 10.6134 10.3 11V13C10.3 13.3866 10.6134 13.7 11 13.7H13C13.3866 13.7 13.7 13.3866 13.7 13V11C13.7 10.6134 13.3866 10.3 13 10.3ZM11 9C9.89543 9 9 9.89543 9 11V13C9 14.1046 9.89543 15 11 15H13C14.1046 15 15 14.1046 15 13V11C15 9.89543 14.1046 9 13 9H11Z"
      fill="currentColor"
    />
  </svg>
)
